import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_STATUS,
  RESET_STATUS,
  SET_ERROR,
  RESET_CURRENT_CATEGORY_INFO,
  FETCH_REVENUE_CATEGORIES_SUCCESS,
  TOGGLE_CHALLENGERS_SUCCESS,
  FETCH_REVENUE_CATEGORY_SUCCESS,
  TOGGLE_TAGS_SUCCESS,
  FETCH_FILTERS,
  FETCH_ACTIONS
} from "./revenueCategoriesSagas";

export const initialState = {
  isLoading: true,
  revenueCategories: { service: [], product: [] },
  currentRevenueCategoryInfo: null,
  filters: {},
  actions: {},
  status: "idle",
  errors: null
};

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      status: action.payload
    }),
    [RESET_STATUS]: (state) => ({
      ...state,
      status: "idle",
      errors: null
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_REVENUE_CATEGORIES_SUCCESS]: (state, { payload: { data, searchParam } }) => ({
      ...state,
      revenueCategories: data,
      searchParam
    }),
    [FETCH_REVENUE_CATEGORY_SUCCESS]: (state, action) => ({
      ...state,
      currentRevenueCategoryInfo: action.payload
    }),
    [FETCH_FILTERS]: (state, action) => ({
      ...state,
      filters: action.payload
    }),
    [FETCH_ACTIONS]: (state, action) => ({
      ...state,
      actions: action.payload
    }),
    [TOGGLE_CHALLENGERS_SUCCESS]: (state, { payload: { rcoId, challenger } }) => ({
      ...state,
      revenueCategories: {
        ...state.revenueCategories,
        service: state.revenueCategories.service.map((category) =>
          category.rcoId === rcoId ? { ...category, challenger } : category
        )
      }
    }),
    [TOGGLE_TAGS_SUCCESS]: (state, { payload: { id, tags } }) => ({
      ...state,
      currentRevenueCategoryInfo: {
        ...state.currentRevenueCategoryInfo,
        data: state.currentRevenueCategoryInfo.data.map((info) =>
          id.includes(info.id) ? { ...info, ...tags } : info
        )
      }
    }),
    [RESET_CURRENT_CATEGORY_INFO]: (state) => ({
      ...state,
      currentRevenueCategoryInfo: null
    })
  },

  initialState
);
